// Обёртка Haptics (ux/12 §7): только при включённой «Вибрации», не чаще раза в 80 мс, при наложении — сильнейший.
// На вебе — navigator.vibrate (Android), на iOS-вебе ничего.
import type { TgWebApp } from './webapp.js';

export type HapticKind =
  | 'selection' | 'light' | 'medium' | 'heavy' | 'rigid' | 'soft' | 'success' | 'warning' | 'error';

const STRENGTH: Record<HapticKind, number> = {
  selection: 1, light: 2, soft: 2, rigid: 3, medium: 4, heavy: 6, warning: 5, success: 5, error: 7,
};
const WEB_MS: Record<HapticKind, number | number[]> = {
  selection: 5, light: 10, medium: 20, heavy: 35, rigid: 15, soft: 10,
  success: [20, 40, 20], warning: [30, 30], error: [50, 30, 50],
};
export const HAPTIC_THROTTLE_MS = 80;

export function createHaptics(deps: { wa: () => TgWebApp | null; enabled: () => boolean; now?: () => number; vibrate?: (p: number | number[]) => void }) {
  const now = deps.now ?? (() => performance.now());
  let lastAt = -Infinity;
  let lastStrength = 0;
  return function haptic(kind: HapticKind): boolean {
    if (!deps.enabled()) return false;
    const t = now();
    if (t - lastAt < HAPTIC_THROTTLE_MS && STRENGTH[kind] <= lastStrength) return false;
    lastAt = t;
    lastStrength = STRENGTH[kind];
    const hf = deps.wa()?.HapticFeedback;
    if (hf) {
      if (kind === 'selection') hf.selectionChanged();
      else if (kind === 'success' || kind === 'warning' || kind === 'error') hf.notificationOccurred(kind);
      else hf.impactOccurred(kind);
    } else {
      deps.vibrate?.(WEB_MS[kind]);
    }
    return true;
  };
}
